@if (enabled) {
  <div class="d-flex justify-content-center">
    <div class="card card-nb card-mw-300 rounded-lg">
      <div class="card-body">
        @if (status !== 'saved') {
          <div>
            <div class="d-flex align-items-center">
              <div class="h3 red">{{ 'save_draft' | i18next }}</div>
            </div>
            <p class="card-text">
              {{ 'save_draft_description' | i18next }}
            </p>
            @if (status === 'error') {
              <div class="alert alert-danger mt-2">
                <p class="mb-1">{{ 'draft_save_error_description' | i18next }}</p>
                <button class="btn btn-link p-0" (click)="onSaveDraft()">{{ 'draft_save_retry' | i18next }}</button>
              </div>
            }
            @if (status === 'failed') {
              <div class="alert alert-danger mt-2">
                <p class="mb-1">{{ 'draft_save_failed_description' | i18next }}</p>
                <button class="btn btn-link p-0" (click)="onCloseDraft()">{{ 'draft_save_close_without_saving' | i18next }}</button>
              </div>
            }
            @if (status !== 'error' && status !== 'failed') {
              <div class="d-flex justify-content-end">
                <button class="btn btn-link" [disabled]="status === 'saving'" (click)="onSaveDraft()">{{ 'save_as_draft_continue_later' | i18next }}</button>
              </div>
            }
          </div>
        }
        @if (status === 'saved') {
          <div>
            <div class="h3">{{ 'draft_saved' | i18next }}</div>
            <p class="card-text">
              {{ 'draft_saved_description' | i18next }}
            </p>
            <div class="d-flex justify-content-end">
              <button class="btn btn-link" (click)="onCloseDraft()">{{ 'close' | i18next }}</button>
            </div>
          </div>
        }
      </div>
    </div>
  </div>
}
